<script>
  import Circle from './Circle.svelte';

  export let id = 'stepper';
  export let currentStep = 1;
  export let steps = [
    {
      order: 1,
      label: 'Step 1',
      done: false
    },
    {
      order: 2,
      label: 'Step 2',
      done: false
    },
    {
      order: 3,
      label: 'Step 3',
      done: false
    }
  ];

  $: for(let i = 0; i < steps.length; i++){
    if(steps[i].order < currentStep){
      steps[i].done = true;
    } else {
      steps[i].done = false;
    }
  }


</script>

<style>
  .stepper {
    margin-bottom: 30px;
  }

  .visual-indicator {
    display: flex;
    align-items: center;
  }

  .line {
    display: inline-flex;
    height: 3px;
    background-color: rgba(0, 0, 0, 0.38);
    flex: 1;
  }

  .line.done {
    background-color: #28a745;
  }

  .text-label {
    display: flex;
    justify-content: space-between;
  }
</style>

<div {id} class="stepper">
  <div class="visual-indicator">
    {#each steps as step, i}
      <Circle current={step.order === currentStep} text={step.order} done={step.done} />
      {#if i < steps.length-1}
      <span class="line" class:done={step.done} />
      {/if}
    {/each}
  </div>
  <div class="text-label">
  {#each steps as step, i}
    <strong>{step.label}</strong>
  {/each}

  </div>
</div>
